import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild } from '@angular/core';
import { Theme } from '../service/AutoTheme';
import { BehaviorSubject } from 'rxjs';
import { Custdisposition } from '../../common/model/crm.model';


@Component({
  selector: 'app-dialer-disposition',
  templateUrl: './dialer-disposition.component.html',
  styleUrls: ['./dialer-disposition.component.css']
})

export class DialerDispositionComponent implements OnInit {
  public show: boolean = true
  public isauto: boolean = false;
  public isrecruiting: boolean = false;
  public ismortgage: boolean = false;
  public isdialmortgage: boolean = false;
  private __dispodata = new BehaviorSubject<any>(null);
  public disposolution = this.__dispodata.asObservable();
  public custdispostion: Custdisposition[];
  loading: boolean;
  rows: any;

  constructor(public theme: Theme) { }

  @Output() dialdisposition = new EventEmitter();
  @Output() cbdisposition = new EventEmitter();
  @Output() autodisposition = new EventEmitter();
  @Output() mortgagedisposition = new EventEmitter();
  @Input() set dispobutton(v: Custdisposition[]) {
    console.log("Setting current obserable");
    console.log(v);
    this.__dispodata.next(v);
  }

  ngOnInit() {

    /*  if(sessionStorage.getItem("currcampaign") == "1")
       this.ismortgage=true; 
     if(sessionStorage.getItem("currcampaign") == "3")
       this.ismortgage=true; 
     if(sessionStorage.getItem("currcampaign") == "2")
       this.ismortgage=true; */
    // if(sessionStorage.getItem("currcampaign") == "4")
    //   this.isdialmortgage=true;

    this.disposolution.subscribe(res => {
      if (res != null && res != undefined) {
        console.log(res);
        this.custdispostion = res;
      }
    });
  }

  onCbClick(dispo: Custdisposition) {
    console.log("Current Disposition::");
    console.log(dispo);
    this.cbdisposition.emit(dispo);
  }

  onDispoClick(row: Custdisposition) {
    this.dialdisposition.emit(row);
  }

  onAutoClick(dispo: Custdisposition) {
    console.log("Current Disposition::" + dispo);
    this.autodisposition.emit(dispo);
  }

  onMortgageClick(dispo: Custdisposition) {
    console.log("Current Disposition::" + dispo);
    this.mortgagedisposition.emit(dispo);
  }

  @ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;

  public scrollRight(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft + 300), behavior: 'smooth' });
  }
  
  public scrollLeft(): void {
    this.widgetsContent.nativeElement.scrollTo({ left: (this.widgetsContent.nativeElement.scrollLeft - 300), behavior: 'smooth' });
  }

}
